export type PrimaryColorConfig = {
  name?: string
  light?: string
  main: string
  dark?: string
}

// Primary color config object
const primaryColorConfig: PrimaryColorConfig[] = [
  {
    name: 'primary-1',
    light: '#E87333',
    main: '#DD4A00',
    dark: '#A13700'
  }
]

export default primaryColorConfig
